import React from "react";
import styled, { keyframes } from "styled-components";
import {
    BrowserRouter as Router,
    Route,
    Link,
    NavLink,
    Redirect
  } from "react-router-dom";
import { SaveButton } from "../../components/buttons/SaveButton";
import { RematchButton } from "../../components/buttons/RematchButton";
import Canvas from "../../components/game/Canvas";

const StyledBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: linear-gradient(180deg, #5B0BA2 0%, #342C3A 100%), #504458;;
  color: white;
  pointer-events: none;
  user-select: none;
  -webkit-user-drag: none;
  width: 100%;
  height: 100%;
  -webkit-tap-highlight-color: transparent;
`;

const StyledReviewBanner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  padding-top: 16px;

  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  height: 120px;
  background: none;
`;

const StyledCanvasDraw = styled.div`
  position: absolute;
  left: 8px;
  right: 8px;
  top: 136px;
  bottom: 100px;
  pointer-events: none;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #ff6c64;
  box-sizing: border-box;
  box-shadow: 0px 8px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  animation: ${fadeInUp} 1s cubic-bezier(0.19, 1, 0.22, 1) 1;
  animation-delay: 2s;
  animation-fill-mode: backwards;
`;

const StyledButtonsWrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  min-height: 100px;
  pointer-events: none;
  visibility: show;

  a {
    text-decoration: none;
  }
`;

const fadeInUp = keyframes`
from {
    opacity:0;
    transform: translateY(200%);
  }

  to {
    opacity:1;
    transform: translateY(0%);
  }
`;


const AnimatedButton = styled.div`
  animation: ${fadeInUp} 0.4s cubic-bezier(0.19, 1, 0.22, 1) 1;
  animation-delay: ${props => props.delay};
  animation-fill-mode: backwards;
`;

export default class ReviewScreen extends React.Component {
  constructor(props) {
    super(props);
    this.canvasDraw = [];
    this.dataURL = "";
    this.state = {
        readyToSave:false
    }
  }

  componentDidMount() {
    console.log(this.dataURL)
  }

  handleSaveClick = () => {
    this.dataURL = this.canvasDraw.getDataURI();
    this.props.onSave(this.dataURL);
    console.log("Clicked save")
  }

  handleRematchClick = () => {
      this.props.onRematch();
      console.log("Clicked rematch")
  };

  handleFinishedDrawing = () => {
    this.setState({
        readyToSave: true
      })
      
  }

  render() {
    let rematchbutton; 
    
    rematchbutton = <RematchButton onClick={this.handleRematchClick}/>;
    let savebutton;
    savebutton = <SaveButton active={this.state.readyToSave} onClick={this.handleSaveClick} text="Save" />;
    let animatedDrawingButtons;

    animatedDrawingButtons = (
      <React.Fragment>
        <AnimatedButton delay="0.4s">{savebutton}</AnimatedButton>
        <AnimatedButton delay="0.6s">{rematchbutton}</AnimatedButton>
        
      </React.Fragment>
    );
    return (
      <StyledBackground>
        <StyledReviewBanner>
          <div>
            <svg
              width="330"
              height="75"
              viewBox="0 0 330 75"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d)">
                <mask
                  id="path-1-outside-1"
                  maskUnits="userSpaceOnUse"
                  x="-1"
                  y="0"
                  width="331"
                  height="67"
                  fill="black"
                >
                  <rect fill="white" x="-1" width="331" height="67" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M46.289 1C44.6321 1 43.289 2.34314 43.289 4V17.63L1 21.7539L1.07285 22.8591L19.7177 42.1706L3.84062 64.8486L3.87705 65.4012L60.6329 59.8665L60.789 59.9912L59.789 46.0036H269.289L268.289 60.59L268.435 60.4644L325.201 66L325.237 65.4474L309.36 42.7694L328.005 23.4579L328.078 22.3527L285.289 18.1801V4C285.289 2.34315 283.946 1 282.289 1H46.289Z"
                  />
                </mask>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M46.289 1C44.6321 1 43.289 2.34314 43.289 4V17.63L1 21.7539L1.07285 22.8591L19.7177 42.1706L3.84062 64.8486L3.87705 65.4012L60.6329 59.8665L60.789 59.9912L59.789 46.0036H269.289L268.289 60.59L268.435 60.4644L325.201 66L325.237 65.4474L309.36 42.7694L328.005 23.4579L328.078 22.3527L285.289 18.1801V4C285.289 2.34315 283.946 1 282.289 1H46.289Z"
                  fill="black"
                />
                <path
                  d="M43.289 17.63L43.386 18.6253C43.8983 18.5753 44.289 18.1447 44.289 17.63H43.289ZM1 21.7539L0.902943 20.7587C0.365427 20.8111 -0.0333567 21.2808 0.00216544 21.8197L1 21.7539ZM1.07285 22.8591L0.0750153 22.9249C0.0905666 23.1608 0.18921 23.3836 0.353435 23.5537L1.07285 22.8591ZM19.7177 42.1706L20.5369 42.7441C20.8114 42.352 20.7696 41.8204 20.4371 41.476L19.7177 42.1706ZM3.84062 64.8486L3.02143 64.2751C2.89083 64.4616 2.82781 64.6871 2.84279 64.9143L3.84062 64.8486ZM3.87705 65.4012L2.87921 65.4669C2.89701 65.737 3.02353 65.9883 3.22986 66.1635C3.4362 66.3387 3.70472 66.4227 3.9741 66.3965L3.87705 65.4012ZM60.6329 59.8665L61.2573 59.0854C61.0539 58.9228 60.7951 58.8459 60.5359 58.8712L60.6329 59.8665ZM60.789 59.9912L60.1646 60.7724C60.4749 61.0204 60.9026 61.0612 61.2542 60.8764C61.6059 60.6916 61.8148 60.3161 61.7864 59.9199L60.789 59.9912ZM59.789 46.0036V45.0036C59.5114 45.0036 59.2463 45.119 59.0571 45.3222C58.8679 45.5253 58.7717 45.798 58.7915 46.0749L59.789 46.0036ZM269.289 46.0036L270.287 46.072C270.306 45.7956 270.209 45.5236 270.02 45.3211C269.831 45.1186 269.566 45.0036 269.289 45.0036V46.0036ZM268.289 60.59L267.291 60.5216C267.264 60.9237 267.48 61.3031 267.841 61.4838C268.201 61.6646 268.634 61.6114 268.94 61.3489L268.289 60.59ZM268.435 60.4644L268.532 59.4691C268.261 59.4427 267.991 59.528 267.784 59.7055L268.435 60.4644ZM325.201 66L325.104 66.9953C325.373 67.0215 325.642 66.9375 325.848 66.7623C326.054 66.5871 326.181 66.3358 326.199 66.0657L325.201 66ZM325.237 65.4474L326.235 65.5132C326.25 65.2859 326.187 65.0604 326.056 64.8739L325.237 65.4474ZM309.36 42.7694L308.641 42.0749C308.308 42.4192 308.267 42.9509 308.541 43.343L309.36 42.7694ZM328.005 23.4579L328.725 24.1525C328.889 23.9824 328.987 23.7596 329.003 23.5237L328.005 23.4579ZM328.078 22.3527L329.076 22.4185C329.111 21.8796 328.713 21.4099 328.175 21.3575L328.078 22.3527ZM285.289 18.1801H284.289C284.289 18.6948 284.68 19.1254 285.192 19.1754L285.289 18.1801ZM44.289 4C44.289 2.89543 45.1844 2 46.289 2V0C44.0798 0 42.289 1.79086 42.289 4H44.289ZM44.289 17.63V4H42.289V17.63H44.289ZM1.09706 22.7492L43.386 18.6253L43.1919 16.6347L0.902943 20.7587L1.09706 22.7492ZM2.07068 22.7933L1.99783 21.6882L0.00216544 21.8197L0.0750153 22.9249L2.07068 22.7933ZM20.4371 41.476L1.79227 22.1645L0.353435 23.5537L18.9983 42.8652L20.4371 41.476ZM4.65981 65.4221L20.5369 42.7441L18.8985 41.5971L3.02143 64.2751L4.65981 65.4221ZM4.87488 65.3354L4.83846 64.7828L2.84279 64.9143L2.87921 65.4669L4.87488 65.3354ZM60.5359 58.8712L3.77999 64.4059L3.9741 66.3965L60.73 60.8618L60.5359 58.8712ZM61.4133 59.2101L61.2573 59.0854L60.0086 60.6476L60.1646 60.7724L61.4133 59.2101ZM58.7915 46.0749L59.7915 60.0625L61.7864 59.9199L60.7864 45.9323L58.7915 46.0749ZM269.289 45.0036H59.789V47.0036H269.289V45.0036ZM268.291 45.9352L267.291 60.5216L269.287 60.6584L270.287 46.072L268.291 45.9352ZM268.94 61.3489L269.087 61.2233L267.784 59.7055L267.638 59.8311L268.94 61.3489ZM268.338 61.4597L325.104 66.9953L325.298 65.0047L268.532 59.4691L268.338 61.4597ZM326.199 66.0657L326.235 65.5132L324.239 65.3817L324.203 65.9342L326.199 66.0657ZM326.056 64.8739L310.179 42.1959L308.541 43.343L324.418 66.0209L326.056 64.8739ZM310.08 43.464L328.725 24.1525L327.286 22.7634L308.641 42.0749L310.08 43.464ZM329.003 23.5237L329.076 22.4185L327.08 22.287L327.007 23.3922L329.003 23.5237ZM328.175 21.3575L285.386 17.1848L285.192 19.1754L327.981 23.348L328.175 21.3575ZM284.289 4V18.1801H286.289V4H284.289ZM282.289 2C283.394 2 284.289 2.89543 284.289 4H286.289C286.289 1.79086 284.498 0 282.289 0V2ZM46.289 2H282.289V0H46.289V2Z"
                  fill="#FED845"
                  mask="url(#path-1-outside-1)"
                />
              </g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.87714 65.4012L60.6948 59.8605L57.8178 16.2132L1.00009 21.7539L1.07294 22.8591L19.7178 42.1706L3.84071 64.8486L3.87714 65.4012Z"
                fill="#F2C94C"
              />
              <path
                d="M59.7891 46.0036L60.7891 59.9912L43.2891 46.0036H59.7891Z"
                fill="#997F30"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M325.201 66L268.383 60.4593L271.26 16.812L328.078 22.3527L328.005 23.4579L309.36 42.7694L325.237 65.4474L325.201 66Z"
                fill="#C7780F"
              />
              <path
                d="M269.289 46.0036L268.289 60.59L285.289 46.0036H269.289Z"
                fill="#997F30"
              />
              <path
                d="M43.2891 4C43.2891 2.34314 44.6322 1 46.2891 1H282.289C283.946 1 285.289 2.34315 285.289 4V46.0036H43.2891V4Z"
                fill="#FDB513"
              />
              <path d="M105.825 0H125.825L94 47H74L105.825 0Z" fill="#FFE993" />
              <path
                d="M102.58 22.56L98.4515 13.656H101.548L104.068 18.864H104.212C104.404 18.448 104.604 18.024 104.812 17.592C105.02 17.16 105.236 16.72 105.46 16.272L106.708 13.656H109.78L105.508 22.584V30H102.58V22.56ZM117.745 13.656C118.385 13.656 118.993 13.784 119.569 14.04C120.145 14.28 120.649 14.616 121.081 15.048C121.513 15.48 121.849 15.992 122.089 16.584C122.345 17.16 122.473 17.776 122.473 18.432V25.248C122.473 25.904 122.345 26.52 122.089 27.096C121.849 27.672 121.513 28.176 121.081 28.608C120.649 29.04 120.145 29.384 119.569 29.64C118.993 29.88 118.385 30 117.745 30H115.873C115.217 30 114.601 29.88 114.025 29.64C113.449 29.384 112.945 29.04 112.513 28.608C112.097 28.176 111.761 27.672 111.505 27.096C111.249 26.52 111.121 25.904 111.121 25.248V18.432C111.121 17.776 111.249 17.16 111.505 16.584C111.761 15.992 112.097 15.48 112.513 15.048C112.945 14.616 113.449 14.28 114.025 14.04C114.601 13.784 115.217 13.656 115.873 13.656H117.745ZM119.545 18.576C119.545 18 119.377 17.512 119.041 17.112C118.721 16.712 118.281 16.512 117.721 16.512H115.897C115.337 16.512 114.889 16.712 114.553 17.112C114.233 17.512 114.073 18 114.073 18.576V25.08C114.073 25.656 114.233 26.152 114.553 26.568C114.889 26.968 115.337 27.168 115.897 27.168H117.721C118.281 27.168 118.721 26.968 119.041 26.568C119.377 26.152 119.545 25.656 119.545 25.08V18.576ZM136.119 25.248C136.119 25.904 135.999 26.52 135.759 27.096C135.519 27.672 135.183 28.176 134.751 28.608C134.319 29.04 133.815 29.384 133.239 29.64C132.663 29.88 132.047 30 131.391 30H129.543C128.887 30 128.271 29.88 127.695 29.64C127.119 29.384 126.607 29.04 126.159 28.608C125.727 28.176 125.383 27.672 125.127 27.096C124.887 26.52 124.767 25.904 124.767 25.248V13.656H127.719V25.08C127.719 25.368 127.767 25.64 127.863 25.896C127.975 26.136 128.119 26.352 128.295 26.544C128.487 26.736 128.703 26.888 128.943 27C129.199 27.112 129.463 27.168 129.735 27.168H131.175C131.447 27.168 131.703 27.112 131.943 27C132.199 26.888 132.415 26.736 132.591 26.544C132.767 26.352 132.911 26.136 133.023 25.896C133.135 25.64 133.191 25.368 133.191 25.08V13.656H136.119V25.248ZM156.384 13.656H163.848C164.376 13.656 164.872 13.768 165.336 13.992C165.816 14.216 166.232 14.528 166.584 14.928C166.936 15.328 167.208 15.792 167.4 16.32C167.608 16.832 167.712 17.384 167.712 17.976V25.68C167.712 26.288 167.608 26.848 167.4 27.36C167.208 27.872 166.936 28.328 166.584 28.728C166.232 29.128 165.816 29.44 165.336 29.664C164.872 29.888 164.376 30 163.848 30H156.384V13.656ZM163.104 26.976C163.344 26.976 163.56 26.928 163.752 26.832C163.944 26.736 164.112 26.608 164.256 26.448C164.416 26.288 164.536 26.104 164.616 25.896C164.696 25.672 164.736 25.432 164.736 25.176V18.456C164.736 18.216 164.696 17.992 164.616 17.784C164.536 17.56 164.416 17.368 164.256 17.208C164.112 17.032 163.944 16.896 163.752 16.8C163.56 16.704 163.344 16.656 163.104 16.656H159.384V26.976H163.104ZM170.072 13.656H173.12V30H170.072V13.656ZM175.556 13.656H183.02C183.548 13.656 184.044 13.768 184.508 13.992C184.988 14.216 185.404 14.528 185.756 14.928C186.108 15.328 186.38 15.792 186.572 16.32C186.78 16.832 186.884 17.384 186.884 17.976V25.68C186.884 26.288 186.78 26.848 186.572 27.36C186.38 27.872 186.108 28.328 185.756 28.728C185.404 29.128 184.988 29.44 184.508 29.664C184.044 29.888 183.548 30 183.02 30H175.556V13.656ZM182.276 26.976C182.516 26.976 182.732 26.928 182.924 26.832C183.116 26.736 183.284 26.608 183.428 26.448C183.588 26.288 183.708 26.104 183.788 25.896C183.868 25.672 183.908 25.432 183.908 25.176V18.456C183.908 18.216 183.868 17.992 183.788 17.784C183.708 17.56 183.588 17.368 183.428 17.208C183.284 17.032 183.116 16.896 182.924 16.8C182.732 16.704 182.516 16.656 182.276 16.656H178.556V26.976H182.276ZM207.29 13.656H210.338V30H207.29V13.656ZM216.159 16.68H211.983V13.656H223.311V16.68H219.087V30H216.159V16.68ZM228.731 25.872H225.923V12.6H228.731V25.872ZM228.731 30H225.923V27.192H228.731V30Z"
                fill="#332A10"
              />
              <defs>
                <filter
                  id="filter0_d"
                  x="0"
                  y="0"
                  width="329.078"
                  height="75"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  />
                  <feOffset dy="8" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
        </StyledReviewBanner>
        <StyledCanvasDraw>
          <Canvas
            ref={canvasDraw => (this.canvasDraw = canvasDraw)}
            width={this.props.canvasWidth}
            height={this.props.canvasHeight}
            savedCanvas={this.props.savedCanvas}
            loadDelay={800}
            onFinishedDrawing={this.handleFinishedDrawing}
          />
        </StyledCanvasDraw>
        <StyledButtonsWrapper>{animatedDrawingButtons}</StyledButtonsWrapper>
      </StyledBackground>
    );
  }
}
